import React from "react";
import PropTypes from "prop-types";
import { CustomInput } from "reactstrap";

const CheckBox = ({ id = "checkbox", label, name, onChange, checked = false, style }) => {
  return (
    <CustomInput
      id={id}
      className="mb-3"
      type="checkbox"
      name={name}
      label={label}
      style={style}
      checked={checked}
      onChange={onChange}
    />
  );
};

export default CheckBox;

CheckBox.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  style: PropTypes.any,
  checked: PropTypes.bool,
  onChange: PropTypes.func
};
